var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 0C14.1047 0 0 14.1047 0 31.5C0 48.8953 14.1047 63 31.5 63C48.8953 63 63 48.8953 63 31.5C63 14.1047 48.8953 0 31.5 0ZM45.1055 21.2133L30.2977 41.7445C30.0907 42.0334 29.8179 42.2688 29.5018 42.4312C29.1857 42.5935 28.8354 42.6782 28.4801 42.6782C28.1247 42.6782 27.7745 42.5935 27.4584 42.4312C27.1423 42.2688 26.8695 42.0334 26.6625 41.7445L17.8945 29.5945C17.6273 29.2219 17.8945 28.7016 18.3516 28.7016H21.6492C22.3664 28.7016 23.0484 29.0461 23.4703 29.6367L28.4766 36.5836L39.5297 21.2555C39.9516 20.6719 40.6266 20.3203 41.3508 20.3203H44.6484C45.1055 20.3203 45.3727 20.8406 45.1055 21.2133Z",
    fill: "#52C41A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheckIcon);
export default __webpack_public_path__ + "static/media/success-check-icon.f33b35e4120a7eb23d8c149cce7a2af7.svg";
export { ForwardRef as ReactComponent };